module.exports = __webpack_public_path__ + "assets/b94719c1cdf9f38a4e8e2d2d5c34026f.mp3";